import { CartItem } from "@/redux/slice/cart/types/CartItem";
import { getShipmentItemPrice } from "@/redux/slice/cart/utils/getShipmentItemPrice";

export const createCartItemFromProduct = (product: CartItem, attributes?: Partial<CartItem>): CartItem => {
  return {
    ...product,
    quantity: product.quantity ? product.quantity : 1,
    isShippable: true,
    sell_online: true,
    sellingPrice: getShipmentItemPrice(product), // updated in server cart response
    ...attributes,
  };
};
